import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M10.25 9.5a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M5 9.5a7 7 0 1 1 12.923 3.733l2.727 4.722a.751.751 0 0 1-.796 1.11l-2.616-.52-.858 2.526a.75.75 0 0 1-1.36.134l-2.72-4.711c-.2.008-.4.008-.6 0l-2.72 4.71a.75.75 0 0 1-1.36-.131l-.861-2.52-2.614.513a.749.749 0 0 1-.795-1.11l2.727-4.723A6.97 6.97 0 0 1 5 9.5Zm2.086 4.985a7 7 0 0 0 3.027 1.758l-1.607 2.783-.54-1.58a.75.75 0 0 0-.854-.492l-1.637.322 1.611-2.791Zm6.801 1.758 1.605 2.779.537-1.581a.75.75 0 0 1 .856-.495l1.638.326-1.609-2.787a6.999 6.999 0 0 1-3.027 1.758ZM12 6.25a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }